import api from "../../api";

export * from "./user-levels.inits";

/** @type {import("vuex/types/index.d.ts").Module} */
export const userLevels = {
    namespaced: true,
    state: {
        /** @type {import('./user-levels.inits').UserLevel[]} */
        items: [],
    },
    mutations: {
        setItems(state, { levels }) {
            state.items = levels;
        },
    },
    actions: {
        async getItems({ commit }) {
            let { levels } = await api.console.levels.getLevels();
            commit("setItems", { levels });
            return levels;
        },
    },
};

export default userLevels;
